import React from "react";
import { useSearchParams } from "react-router-dom";

import { useClaimProperties } from "../../hooks/useClaimProperties";
import { getSearchParamNumber } from "../../services/nav/QueryStringHelpers";
import { MID_FI_FIELD_CLASS, MidFiFieldLabel } from "./DetailFilterBar";

// Property control for the detail pages' filter bar (low-fi sheets: "Property ▾" leads every bar).
// Switching keeps the current page and company, and only changes ?property=.
export const FilterPropertySelect = () => {
  const properties = useClaimProperties();
  const [params, setParams] = useSearchParams();
  const selectedId = getSearchParamNumber("property", params);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const next = new URLSearchParams(params);
    next.set("property", event.target.value);
    setParams(next);
  };

  return (
    <label className={`${MID_FI_FIELD_CLASS} text-mf-ink`}>
      <MidFiFieldLabel>Property</MidFiFieldLabel>
      <select
        className="cursor-pointer bg-transparent text-mf-ink outline-none"
        value={selectedId != null ? String(selectedId) : ""}
        onChange={handleChange}
        disabled={properties.length === 0}
        aria-label="Property"
      >
        {selectedId == null || !properties.some((p) => p.propertyId === selectedId) ? (
          <option value="">{properties.length ? "Select a property" : "No properties"}</option>
        ) : null}
        {properties.map((p) => (
          <option key={p.propertyId} value={String(p.propertyId)}>
            {p.propertyName}
          </option>
        ))}
      </select>
    </label>
  );
};
